import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3583ydpmlg: FaireBrandEntity = {
  token: "b_3583ydpmlg",
  type: "brand",
  name: "M5 Corporation",
  avatarUrl:
    "https://cdn.faire.com/fastly/a9d98bb3001eaa9f8f34959af3a944433f0690a637b354d50d4751aacb28d82f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c8ccc91537ad356c6b581ad5f6c0cbe27447c5f9fec32725982a152fda5041a3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a9d98bb3001eaa9f8f34959af3a944433f0690a637b354d50d4751aacb28d82f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c8ccc91537ad356c6b581ad5f6c0cbe27447c5f9fec32725982a152fda5041a3.png",
  location: "San Marcos, CA, USA",
  minimumOrderDollars: 120,
  rating: 4.9,
  reviewCount: 140,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a family owned and operated gourmet import and distribution company started by my late Grandfather, Elgie McGrath, in 2005. We work directly with small, high-end & family owned producers from remote areas of the world to bring gourmet culturally authentic foods to your door.\n\nWe are proud to re-launch the brand HLTHPUNK. With their world famous Smoked Harissa, Indian Curry Paste, and Dijon mustard. All 100% organic deliciousness.\n\nWe are the exclusive importer of many premier gourmet brands from around the world. Including incredible brands like Yamaroku, Mussini, Riso Gallo, Kolsvart, HLTHPUNK, Terre Francescane, Etnia, Delizie Di Calabria, Donne Del Grano, Trulli Sassi and more!!!\n\n- Zach McGrath (Far Left in both Pictures)",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.308Z",
    importedBy: "entity-db-cli",
  },
};
